import ws from "./fs-ws.png";
import phone from "./phone.jpg";

const IMGS = {
  ws: ws,
  phone: phone
};

export default IMGS;
